import React from "react";
import classes from "./style.module.scss";
import useStyles from "isomorphic-style-loader/useStyles";
import Badge from "../../../../components/badge";
import { Link } from "react-router-dom";
import { Iconfont } from "../../../../components/icon/iconfont";
import withEl from '../../../../hocs/el-scroll';
import { FormattedMessage } from "react-intl";


export const MeNumberIcon = withEl((props) =>{
    useStyles(classes);
    const { themeColor, handleClick, innerRef } = props;

    return props.to ? <Link ref={innerRef} to={props.to} className={`${classes.MeNumberIcon}`} onClick={(evt) =>handleClick(evt, props.to, 1)}>
        <div className={classes.IconOrFont}>
            {
                props?.count > 0 ? <React.Fragment>
                    <span className={classes.Font}>{props.count}</span>
                </React.Fragment> : <React.Fragment>
                    <span className={classes.IconItem}>
                        <Iconfont style={themeColor ? {color:themeColor} : {}} className={`${classes.Icon} ${props?.className?props.className:''}`} dangerouslySetInnerHTML={{ __html: props.icon }} />
                        {
                            props?.number > 0 && <span className={`${classes.IconNumber} ${props?.number < 10 ? classes.SmallIconNumber : ''}`}>{props.number}</span>
                        }

                        {
                            props?.new && <span className={classes.IconNew}><span><FormattedMessage id="new_in" defaultMessage="New" /></span></span>
                        }
                    </span>
                </React.Fragment>
            }
        </div>
      
        {
            props.title && <div className={classes.Title} style={themeColor ? {color:themeColor} : {}}>
                {props.title}
            </div>
        }
    </Link> : <a ref={innerRef} href={props.href} className={`${classes.MeNumberIcon}`} onClick={(evt) =>handleClick(evt, props.href)}>
        <div className={classes.IconOrFont}>
            {
                props?.count > 0 ? <React.Fragment>
                    <span className={classes.Font}>{props.count}</span>
                </React.Fragment> : <React.Fragment>
                    <span className={classes.IconItem}>
                        <Iconfont style={themeColor ? {color:themeColor} : {}} className={`${classes.Icon} ${props?.className?props.className:''}`} dangerouslySetInnerHTML={{ __html: props.icon }} />
                        {
                            props?.number > 0 && <span className={`${classes.IconNumber} ${props?.number < 10 ? classes.SmallIconNumber : ''}`}>{props.number}</span>
                        }

                        {
                            props?.new && <span className={classes.IconNew}>
                                <span><FormattedMessage id="new_in" defaultMessage="New" /></span>
                            </span>
                        }
                    </span>
                </React.Fragment>
            }
        </div>

        {
            props.title && <div className={classes.Title} style={themeColor ? {color:themeColor} : {}}>
                {props.title}
            </div>
        }
    </a>
});

export default props =>{
    useStyles(classes);
    const { handleClick } = props;

    return props.to ? <Link to={props.to} className={`${classes.IconMenu}`} onClick={(e) =>handleClick(e, props.to, true)}>
        <Badge count={props.count} dotted={props.dotted}>
            <Iconfont className={`${classes.Icon} ${props?.className?props.className:''}`} dangerouslySetInnerHTML={{ __html: props.icon }} />
        </Badge>
        {
            props.title && <div className={classes.Title}>
                {props.title}
            </div>
        }
    </Link> : <a href={props.href} className={`${classes.IconMenu}`} onClick={(e) =>handleClick(e, props.href, false)}>
        <Badge count={props.count} dotted={props.dotted}>
            <Iconfont className={classes.Icon} dangerouslySetInnerHTML={{ __html: props.icon }} />
        </Badge>
        {
            props.title && <div className={classes.Title}>
                {props.title}
            </div>
        }
    </a>
}